import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { ROUTES } from 'utils/utils';
import { Row, Col, Card, Icon, Alert, Button } from 'antd';
import { fsdoRegConfig } from '../../forms/registration/formConfig';

const
config = fsdoRegConfig,
{ key } = config;

class DataRow extends Component {
    constructor(props) { super(props); }
    render() {
        let k = null, v = '';
        const { type, value, bgc } = this.props;
        switch(type) {
            case 'name':
                const { fn, mn, ln } = value;
                k = 'Name';
                v = `${fn ? `${fn}` : ''}${mn ? ` ${mn} ` : ' '}${ln ? `${ln}` : ''}`;
                break;

            case 'email':
                k = 'Email Address';
                v = value;
                break;

            case 'phone':
                k = 'Telephone';
                v = value;
                break;

            case 'fsdo':
                k = 'Flight Standards District Office (FSDO)';
                v = value;
                break;
        }

        v = v.length === 0 || v === ' ' ? '-' : v;
        return (
            <Row style={{
                lineHeight: '20px',
                padding: '4px',
                backgroundColor: `${bgc || 'rgb(255, 255, 255)'}`,
                borderRadius: '5px'
            }}>
                <Col span={11}>
                    <span style={{ fontWeight: 'bold' }}>
                        {`${k}:`}
                    </span>
                </Col>
                <Col span={13}>
                    {v}
                </Col>
            </Row>
        );
    }
}

export default class FsdoRequestSubmission extends Component {
    constructor(props) { super(props); }

    highlighter = view => view.map((c, i) => React.cloneElement(c, {
        bgc: ((i + 1) % 2) === 0 ? 'rgb(255, 255, 255)' : '#f3f3f3'
    }));

    render() {
        const
        span = 15,
        rowStyle = { textAlign: 'left', marginBottom: '20px' },
        { services, fsdo, registrationForm } = this.props,
        { contact, fsdoInfo } = fsdo,
        form = registrationForm[key];

        return (
            <div style={{ textAlign: 'center', top: '21%', width: '100%'}}>
                <Row type='flex' justify='space-around' align='middle' style={rowStyle}>
                    <Col span={span}>
                        <Alert
                            showIcon
                            type='warning'
                            message={(<span style={{ fontWeight: 'bold' }}>{'Notice'}</span>)}
                            description={(
                                <div>
                                    <div style={{ marginBottom: '20px', lineHeight: '17px' }}>
                                        {'By clicking on the "I Agree" button below you are confirming that:'}
                                    </div>
                                    <ol style={{ lineHeight: '17px' }}>
                                        <li>{'The Flight Standards District Offce (FSDO) that you entered is a valid U.S.-Based, FAA registered FSDO,'}</li>
                                        <li>{'That you are authorized by said FSDO to validate U.S.-Based Training Providers,'}</li>
                                        <li>{'That all of the information that you have provided is accurate to the best of your knowledge, and'}</li>
                                        <li>{'That you will not allow any other person(s) access to the account, passwords and/or information that you will be receiving from the online portal. '}</li>
                                    </ol>
                                    <div style={{ marginTop: '20px', lineHeight: '17px' }}>{
                                        'If you disagree with any of these TERMS and CONDITIONS, or are completing this ' +
                                        'application under duress of any kind, Click on the "I Disagree" button (below) now.'
                                    }</div>
                                </div>
                            )}
                        />
                    </Col>
                </Row>
                <Row type='flex' justify='space-around' align='middle' style={{...rowStyle, marginBottom: '10px'}}>
                    <Col span={10}>
                        <span style={{ lineHeight: '16px', fontWeight: 'bold' }}>
                            {'The following information is going to be submitted for your Account:'}
                        </span>
                    </Col>
                </Row>
                <Row type='flex' justify='space-around' align='middle' style={{...rowStyle }}>
                    <Col span={10}>
                        <div style={{
                            borderStyle: 'solid',
                            borderWidth: '1px',
                            borderColor: 'rgb(220, 220, 220)',
                            borderRadius: '10px'
                        }}>
                            <Card
                                bodyStyle={{ padding: '0px' }}
                                style={{
                                    borderStyle: 'solid',
                                    borderWidth: '10px',
                                    borderColor: 'rgb(255, 255, 255)',
                                    borderRadius: '10px'
                                }}
                            >
                                {this.highlighter([
                                    <DataRow key='dr0' type='name' value={{
                                        fn: form.firstName,
                                        mn: form.middleName,
                                        ln: form.lastName
                                    }} />,
                                    <DataRow key='dr1' type='phone' value={form.phoneNumber} />,
                                    <DataRow key='dr2' type='email' value={form.emailAddress} />,
                                    <DataRow key='dr3' type='fsdo' value={form.fsdo} />
                                ])}
                            </Card>
                        </div>
                    </Col>
                </Row>
                <Row type='flex' justify='space-around' align='middle' style={{ marginBottom: '20px' }}>
                    <Col span={span}>
                        <Button
                            size='small'
                            style={{ width: '120px', marginRight: '10px', borderRadius: '20px 4px 4px 20px' }}
                            onClick={() => {
                                services.fsdoToggleModal();
                                services.fsdoSubmit(form);
                            }}
                        >
                            {'I Agree'}
                        </Button>
                        <Button
                            size='small'
                            icon='rollback'
                            style={{ width: '120px', borderRadius: '4px' }}
                            onClick={() => services.changeFsdoValidationStep(0)}
                        >
                            {'Back'}
                        </Button>
                        <Link to={ROUTES.ROOT}>
                            <Button
                                size='small'
                                style={{ width: '120px', marginLeft: '10px', borderRadius: '4px 20px 20px 4px' }}
                                onClick={() => services.resetFsdoSubmission()}
                            >
                                {'I Disagree'}
                            </Button>
                        </Link>
                    </Col>
                </Row>
            </div>
        );
    };
}
